import React from "react";
import { Sparkles } from "lucide-react";
import { useCompany } from "@/contexts/CompanyContext";

/**
 * BrandMark - Shows uploaded company logo (if any), else falls back to the gold Sparkles square.
 * Props: size (px), showName (bool), align ("row" | "col")
 */
export default function BrandMark({ size = 36, showName = true, eyebrow = "Event Catering", align = "row" }) {
  const { company } = useCompany();
  const logo = company?.logo_data_url;
  const name = company?.company_name || "HNC";

  const square = (
    <div
      className="rounded-sm flex items-center justify-center overflow-hidden shrink-0"
      style={{
        width: size,
        height: size,
        background: logo ? "transparent" : "linear-gradient(135deg, #D4AF37 0%, #8A7322 100%)",
      }}
    >
      {logo ? (
        <img src={logo} alt={name} className="w-full h-full object-contain" />
      ) : (
        <Sparkles className="w-4 h-4 text-black" style={{ width: size * 0.4, height: size * 0.4 }} />
      )}
    </div>
  );

  if (!showName) return square;

  return (
    <div className={`flex ${align === "row" ? "flex-row items-center gap-2.5" : "flex-col items-center gap-2"}`}>
      {square}
      <div>
        <div className="font-display text-base leading-none">{name.split(" ").slice(0, 3).join(" ")}</div>
        {eyebrow && <div className="text-[10px] tracking-[0.25em] uppercase text-zinc-500 mt-1">{eyebrow}</div>}
      </div>
    </div>
  );
}
